import StartEventHook from './StartEventHook'
import { bidderForCode, loadScript, topmostWindowFrame } from '../utils'
import FillManager from '../FillManager'
import NativoFillMethod from '../fillers/NativoFillMethod'
import Logger from '../Log'

const Log = Logger.for('NativoHook')

export default class NativoStartHook extends StartEventHook {
  constructor () {
    super('NativoStartHook')
  }

  async run (remoteConfig) {
    const bidder = bidderForCode('nativo', remoteConfig.bidders(), true)
    if (!bidder) {
      Log.debug('No nativo, skipping set up')
      return
    }

    Log.debug('Setting up nativo bidder')

    const frame = topmostWindowFrame()
    const _prx = frame.window._prx = frame.window._prx || []
    _prx.push(['cfg.SetNoAutoStart'])

    const test = frame.location.search ? frame.location.search.indexOf('ntv_tm') !== -1 : false
    if (test) {
      Log.info('Nativo test mode, increasing fill method priority')
      bidder.params.ecpm = 11 // make sure its called first for testing
      bidder.params.test = true
    }

    await loadScript('//s.ntv.io/serve/load.js', null, { 'data-ntv-set-no-auto-start': 'true' })

    FillManager.register(new NativoFillMethod(bidder))
  }
}
